import React from 'react';

const PaginationDots = () => <span>...</span>;

export default PaginationDots;
